var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22541 15.1905L4.55599 13.9398L5.43766 13.4679L6.10707 14.7186C6.18307 14.8606 6.33107 14.9493 6.49213 14.9493H9.5175C9.68029 14.9493 9.82958 14.8587 9.90481 14.7144L10.5518 13.4728L11.4387 13.9349L10.7916 15.1765C10.5441 15.6514 10.053 15.9493 9.5175 15.9493H6.49213C5.96228 15.9493 5.47543 15.6577 5.22541 15.1905Z",
    fill: "#EC691A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60031 3.28708C4.91697 -1.04055 11.1272 -1.02462 13.4217 3.31485L14.466 5.28994C14.6763 5.68786 14.4772 6.17932 14.0491 6.3185L12.7701 6.7344C12.3802 6.86119 11.9529 6.72358 11.7102 6.39306L11.2209 5.72655C9.6319 3.56224 6.40471 3.54505 4.79276 5.69231L4.34143 6.29353C4.11289 6.59797 3.72472 6.73665 3.355 6.64593L2.00614 6.31498C1.54624 6.20214 1.31614 5.68596 1.53962 5.26848L2.60031 3.28708ZM12.5376 3.78227C10.6176 0.150849 5.4206 0.137513 3.48193 3.75903L2.5884 5.42818L3.56141 5.66692L3.99303 5.09195C6.00766 2.40828 10.041 2.42976 12.027 5.13475L12.495 5.7723L13.4292 5.46854L12.5376 3.78227Z",
    fill: "#EC691A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40387 8.64785L2.61366 8.90552L3.87207 12.8464C3.92988 13.0274 4.0981 13.1503 4.28813 13.1503H11.6918C11.8811 13.1503 12.0489 13.0283 12.1073 12.8482L13.3844 8.9071L12.5985 8.65491L12.584 8.7105L12.1002 8.58422L12.5834 8.71272C11.3365 13.4014 4.67819 13.4143 3.42922 8.72572L3.40387 8.64785ZM4.61293 9.08422C5.89761 11.9516 10.1019 11.9541 11.3947 9.08422H8.00979V8.08422H11.715C11.8357 7.70452 12.2435 7.49078 12.6275 7.61399L13.9524 8.03914C14.3346 8.16175 14.5444 8.5714 14.4207 8.95316L13.0586 13.1565C12.8665 13.749 12.3146 14.1503 11.6918 14.1503H4.28813C3.663 14.1503 3.10962 13.7461 2.91946 13.1506L1.57795 8.94948C1.45665 8.56962 1.66482 8.1631 2.04393 8.03948L3.35533 7.61186C3.73625 7.48765 4.14572 7.6959 4.2697 8.0769L4.27208 8.08422H8.00979V9.08422H4.61293Z",
    fill: "#EC691A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26436 5.97739L3.25801 6.02389C3.15109 6.80662 3.14925 7.60012 3.25253 8.38334L3.26467 8.4754L2.27326 8.60613L2.26112 8.51407C2.14619 7.64253 2.14824 6.75955 2.26721 5.88855L2.27356 5.84205L3.26436 5.97739Z",
    fill: "#EC691A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7354 8.46784L12.7418 8.42133C12.8487 7.63861 12.8505 6.8451 12.7473 6.06189L12.7351 5.96983L13.7265 5.83909L13.7387 5.93115C13.8536 6.80269 13.8515 7.68568 13.7326 8.55667L13.7262 8.60318L12.7354 8.46784Z",
    fill: "#EC691A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1875 6.29204V5.29204H11.8032V6.29204H4.1875Z",
    fill: "#EC691A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.1875 4.99234C0.1875 4.4675 0.612966 4.04204 1.1378 4.04204H2.51647V5.04204H1.1875V9.26149H2.51647V10.2615H1.1378C0.612964 10.2615 0.1875 9.83602 0.1875 9.31119V4.99234Z",
    fill: "#EC691A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8075 5.04204H13.4777V4.04204H14.8572C15.382 4.04204 15.8075 4.46751 15.8075 4.99234V9.31174C15.8075 9.83657 15.382 10.262 14.8572 10.262H13.7758V9.26204H14.8075V5.04204Z",
    fill: "#EC691A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeIcon);
export default __webpack_public_path__ + "static/media/challengeIcon.e08bfa551c62f871465806c417cb284f.svg";
export { ForwardRef as ReactComponent };